import { useEffect } from "react";

const SITE_URL = "https://tinystem.com";

// Lightweight SEO helper: manages <title>, <meta description>, canonical link,
// Open Graph tags and JSON-LD structured data via direct DOM manipulation.
export function useSeo({ title, description, path, jsonLd }) {
  useEffect(() => {
    if (title) document.title = title;

    const setMeta = (attr, name, content) => {
      if (!content) return;
      let el = document.head.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", "Tiny Stem");
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);

    if (path) {
      const url = `${SITE_URL}${path}`;
      setMeta("property", "og:url", url);
      let link = document.head.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", url);
    }

    let ldEl = document.getElementById("page-jsonld");
    if (jsonLd) {
      if (!ldEl) {
        ldEl = document.createElement("script");
        ldEl.id = "page-jsonld";
        ldEl.type = "application/ld+json";
        document.head.appendChild(ldEl);
      }
      ldEl.textContent = JSON.stringify(jsonLd);
    } else if (ldEl) {
      ldEl.remove();
    }
  }, [title, description, path, jsonLd]);
}
